import {getFirstDayOfPrevMonth, getFirstDayOfYear, getLastDayOfNextMonth, getLastDayOfYear} from 'helpers/utils';

export abstract class CalendarState {
  filtersDateRangeStartCalendar: Date | undefined;

  filtersDateRangeEndCalendar: Date | undefined;

  abstract loadCalendarItems(): void;

  setFiltersCalendar(date: Date, mode: 'month' | 'year') {
    let firstDay: Date, lastDay: Date;
    if (mode === 'month') {
      firstDay = getFirstDayOfPrevMonth(date);
      lastDay = getLastDayOfNextMonth(date);
    } else {
      firstDay = getFirstDayOfYear(date);
      lastDay = getLastDayOfYear(date);
    }
    this.filtersDateRangeStartCalendar = firstDay;
    this.filtersDateRangeEndCalendar = lastDay;
    this.loadCalendarItems();
  }

  setDefaultDateRangeCalendar() {
    if (!this.filtersDateRangeStartCalendar && !this.filtersDateRangeEndCalendar) {
      const date = new Date();
      this.filtersDateRangeStartCalendar = getFirstDayOfPrevMonth(date);
      this.filtersDateRangeEndCalendar = getLastDayOfNextMonth(date);
    }
  }
}
